 <template lang="pug">
  section#files
    template(v-if="loading")
      v-skeleton-loader(
        class="mx-auto my-3"
        type="article"
      )
    template(v-else)
      v-container.py-0(fluid)
        v-row(justify-center, style="overflow: hidden")
          v-col.px-0.py-0(cols="12")
            .files(v-if="parentInstance && parentInstance.id")
              v-list
                template(v-for="(item, index) in filesEntity")
                  app-file-control(
                    entity="ReferenceMatrix",
                    v-model="filesEntity[index]",
                    @downloadFile="downloadfile(item)",
                    @deleteFile="deletefile(index, item.fileName, item.uid, request.id)",
                  )
        v-row
          v-col(v-show="false")
            input(
              ref="files"
              type="file",
              :accept="allowedFormats",
              multiple,
              @change="handleFileUploads()",
            )
</template>

<style lang="sass">
  .header-menu
    border-bottom: 5px solid var(--v-primary-base) !important
    padding-left: 15px
  .table-row
    border-bottom: 1px solid #cccccc
  .actions-header
    text-align: right
    padding-right: 30px
</style>

<script>
import axios from 'axios';
import FileDownload from 'js-file-download';
import EntityMixin from '@/mixins'

export default {
  name: 'DocumentRequestTemplate',
  // TODO be able to set files property name f eg. awesomeFiles, so files will be set at instance. awesomeFiles
  // TODO by default if custom files property is not set set them to instance.files property
  props: {
    parentInstance: {
      type: Object,
      default: () => { return {} }
    },
    isActive: {
      type: Boolean
    },
    entity: {
      type: Object
    },
    filesProperty: {
      type: String,
      default: "files"
    },
    path: {
      type: String
    },
    parentPath: {
      type: String
    },
    localFiles: null,
    localForm: null,
  },
  data: function () {
    return {
      instance: {},
      requests: [],
      filesToUpload: [],
      filesFormData: null,
      filesEntity: [],
      currentDocumentRequestId : null,
      currentDocumentRequestLabel : null,
      allowedFormats : null,
      loading: false,
    }
  },
  watch: {
    isActive: {
      immediate: true,
      handler (val, oldVal) {
        // console.log('[DocumentRequestTemplate][watcher][isActive]', val, oldVal)
        if (val) {
          this.getDocumentRequests();
        }
      },
    },
    parentInstance: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        // console.log('[DocumentRequestTemplate][watcher][parentInstance]', {...val}, {...oldVal})
        if (val) {
          this.instance = val;
        }
      },
    },
  },
  computed: {
      errors() {
          return this.$store.state.errors;
      }
  },
  methods: {
    /*
    Get the error depending on the request Label
    */
    getErrorLabel(requestLabel){
      return this.errors['file.' + requestLabel]
    },
    /*
    Get the error depending on the request Label
    */
    getErrorInvalidFormat(requestLabel){
      return this.errors['file.' + requestLabel + 'Invalid']
    },
    /**
    When click on upload button, set the currentDocumentRequest and the allowed formats
    Also fire the input file dialog, after the variables are set.
    @param {Object} documentRequestId - current Document Request when click
    @param {Object} allowedFormats - all extensions allowed for files
    @param {Object} object - upload file object
    */
    setUploadFile(documentRequest, allowedFormats, object) {
      // this.currentDocumentRequestId = documentRequest.id;
      // this.currentDocumentRequestLabel = documentRequest.label;
      // this.allowedFormats = allowedFormats;
      setTimeout(function() {
          object.click();
      }, 50);
    },
    /**
     * According to the order information, Get all documents both Requests and Required
     */
    async getDocumentRequests() {
      try {
        this.loading = true;
        this.requests = ((await axios.post(`documents/getDocumentRequest/${this.entity.name}`,this.parentInstance)).data)
      } catch (error) {
        console.log(this.$cleanString(error));
      } finally {
        this.loading = false;
      }
    },
    /**
     * If the document is required, set the label adding a '*' character
    @param {Object} label - Label of the document
    @param {Object} isRequired - flag to know if the document is required
     */
    setRequiredLabel(label, isRequired){
      return isRequired ? label + '*' : label
    },
    /**
     * Format the allowedFormat array, to a readable string to display
    @param {Object} allowedFormatsString - array with the allowed Format
     */
    setAllowedFormats(allowedFormatsString){
      return allowedFormatsString.replace(/\[/g, "").replace(/\]/g, "").replace(/"/g, "").replace(/,/g, ", ")
    },
    /**
     * Format the allowedFormat array, to a readable string to display
    @param {Object} allowedFormatsString - array with the allowed Format
     */
    handleFileUploads() {
      // console.log(`[DocumentRequestTemplate][handleFileUploads]`, this.path, this.filesToUpload.map(f => f.documentRequestId));
      this.filesToUpload = [...this.filesToUpload, ..._.map(this.$refs.files.files, file => ({ file, fileType: null, fileName: file.name, documentRequestId: this.currentDocumentRequestId, documentRequestLabel: this.currentDocumentRequestLabel }))];
      this.buildFormData();
      // this.$emit('fileInput', {formData: this.filesFormData, filesToUpload: this.filesToUpload});
      this.$store.commit('SET_INSTANCE_PATH', { path: (this.parentPath ? `${this.parentPath}.` : '') + 'documentsRequestsToUpload', value: this.filesToUpload.map(f => ({DocumentRequestId: f.documentRequestId, DocumentRequestLabel: f.documentRequestLabel, FileName: f.file.name })) });
      this.$store.commit('SET_FORM_DATA', this.filesFormData);
    },

    buildFormData() {
      const fd = new FormData()

      this.filesToUpload.map(f => {
        fd.append('files', f.file)
        fd.append('types', f.fileType)
        fd.append('documentRequestIds', f.documentRequestId)
      })
      fd.append('entity', 'Order')
      this.filesFormData = fd
    },
    /**
     * Remove a specific file of the filesToUpload array
    @param {Object} index - The current index of the array
    @param {Object} documentRequestId - documentRequest Id where the file will be removed
     */
    async removeFile(index, documentRequestId) {
      var others = this.filesToUpload.filter(f => f.documentRequestId != documentRequestId)
      var documentAffected = this.filesToUpload.filter(f => f.documentRequestId == documentRequestId)
      documentAffected.splice(index, 1)
      this.filesToUpload = others.concat(documentAffected)
      this.$store.commit('SET_INSTANCE_PATH', { path: (this.parentPath ? `${this.parentPath}.` : '') + 'documentsRequestsToUpload', value: this.filesToUpload.map(f => ({DocumentRequestId: f.documentRequestId, DocumentRequestLabel: f.documentRequestLabel, FileName: f.file.name})) });
    },
    /**
     * Delete a specific file of the entity
    @param {Object} index - The current index of the array
    @param {Object} fileName - Name of the file to delete
    @param {Object} uid - Uid of the file
    @param {Object} documentRequestId - documentRequest Id where the file will be deleted
     */
    async deletefile(index, fileName, uid, documentRequestId) {
      await axios.delete(`file/media/${this.entity.name}/${this.parentInstance.id}/${uid}`);
      var others = this.filesEntity.filter(f => f.documentRequestId != documentRequestId)
      var documentAffected = this.filesEntity.filter(f => f.documentRequestId == documentRequestId)
      documentAffected.splice(index, 1)
      this.filesEntity = others.concat(documentAffected)
      this.instance[this.filesProperty] = this.filesEntity
    },
    /**
     * Download a specific file of the entity
    @param {Object} fileName - Name of the file to download
    @param {Object} uid - Uid of the file
     */
    async downloadfile(item) {
      let path_parts = item.localDownloadLink.split('/');
      let fileName = path_parts[path_parts.length - 1];
      try {
        if (item.cloudStorageFileId !== null){
          await this.$downloadFile(item, axios);
          return;
        }
        const { data } = await axios.get(`file/media/${this.entity.name}/${this.parentInstance.id}/${fileName}`, { responseType: 'arraybuffer' });
        FileDownload(data, item.fileName);
      } catch(e) {
        console.log('ERROR DOWNLOAD ', e);
      }
    },
  },
  async mounted () {
    if (this.parentInstance && this.parentInstance.id) this.filesEntity = this.instance[this.filesProperty];
    // Set local values on files coming from parent when re rendering this component.
    this.filesToUpload = this.localFiles;
    this.filesFormData = this.localForm;
  }
}
</script>

